import IconBool from "components/IconBool";
const ModalSelectAssetTable = ({itemsShow, setItem}) => {
    const onClickRadio = (e) => {
        setItem({...itemsShow[parseInt(e.target.value)]});
    };


    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th></th>
                <th>UID</th>
                <th>Name</th>
                <th>Description</th>
                <th className="text-center">Active</th>
            </tr>
            </thead>
            <tbody>
            {itemsShow.map((item, index) => (
                <tr key={index} data-idx={index}>
                    <td className="align-middle">
                        <input type="radio" name="radio-asset" value={index} onClick={onClickRadio}/>
                    </td>
                    <td>{item.uid}</td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td className="text-center"><IconBool value={item.active}/></td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default ModalSelectAssetTable

